import React, { useEffect, useState } from 'react'
import InputBox from '../../../../Components/Input'
import ModalDailog from '../../../../Components/Modal'
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { newUserSchema } from './Schema/NewUserSchema';
import { useNavigate } from 'react-router-dom';
import useUserData from '../../../../hooks/useUserData';
import { API_ENDPOINTS } from '../../../../utils/api';
import createAxiosInstance from "../../../../utils/axiosInstance";
import Loader from '../../../../Components/Loader';
import { FiArrowLeft } from 'react-icons/fi';

const CreateNewUser = () => {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const me = useUserData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoding, setIsLoding] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (me && me?.roles[0] !== "admin") {
      navigate("/my-account");
    }
  }, [me])
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitted, isSubmitting },
  } = useForm({
    defaultValues: {
      email: "",
      firstName: "",
      lastName: "",
    },
    resolver: zodResolver(newUserSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const handleCreateUser = async (data: any) => {
    try {
      setIsLoding(true);
      const payload = {
        active: true,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        roles: ["reviewer"],
      };

      const response = await axiosInstance.post(API_ENDPOINTS.BEDFINDER.CREATEUSER, payload);

      if (response.status === 200) {
        setMessage("");
        setIsLoding(false);
        setIsModalOpen(true);
      }
    } catch (error: any) {
      if (error?.response?.data?.data?.error) {
        if (error?.response?.data?.data?.error?.message?.value) {
          setMessage(error?.response?.data?.data?.error?.message?.value);
        } else {
          setMessage("Registration failed. Please try again!");
        }
      }
      setIsLoding(false);
      setIsModalOpen(true);
    }
  };

  const closeModalSheltercc = () => {
    if (!message) {
      navigate("/my-account");
    } else {
      setValue("email", "", { shouldValidate: true });
      setIsModalOpen(false);
    }
  };

  const displayMessage = () => {
    const str =
      message || "An activation link was sent to the email you provided.";
    return <div dangerouslySetInnerHTML={{ __html: str }}></div>;
  };

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full md:w-1/2">
          <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold'>Create a new User</h2>
          <form
            className="row signin-form"
            onSubmit={handleSubmit(handleCreateUser)}
            noValidate
          >
            <div className="card mt-5 p-4 md:p-6">
              <div className="mb-5">
                <InputBox
                  type="email"
                  label="Email Address"
                  placeholder='Enter email address'
                  {...register("email")}
                />
                <label className="text-error">
                  {errors?.email?.message}
                </label>
              </div>
              <div className="mb-5">
                <InputBox
                  type="text"
                  label="First name"
                  placeholder='Enter first name'
                  {...register("firstName")}
                />
                <label className="text-error">
                  {errors?.firstName?.message}
                </label>
              </div>
              <div className="mb-5">
                <InputBox
                  type="text"
                  label="Last name"
                  placeholder='Enter last name'
                  {...register("lastName")}
                />
                <label className="text-error">
                  {errors?.lastName?.message}
                </label>
              </div>
              <div className="flex justify-end items-center mt-4 gap-3">
                <button
                  type="button"
                  className="min-h-[38px] min-w-24 py-2 bg-white border border-borderGray px-3 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg"
                  onClick={() => navigate("/my-account")}
                >
                  <FiArrowLeft />
                  <span>Back</span>
                </button>
                <button type="submit" disabled={isSubmitting} className='btn btn-primary w-fit'>Create New User</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ModalDailog isOpen={isModalOpen} onClose={closeModalSheltercc} title="Shelter admin invitation" primaryButton='Ok' isXAvailable={false}>
        <p className='text-sm 2xl:text-lg text-gray-600'>{displayMessage()}</p>
      </ModalDailog>
    </>
  )
}

export default CreateNewUser